const _ = require('lodash');
const specificKeyMapper = (key) => {
	const fixedKeys = {
		producttitle: 'title',
		productname: 'name',
		defaultproductsku: 'SKU'
	};
	const match = fixedKeys[key];
	if (_.isUndefined(match)) return key;
	return match;
};

function buildAdditionalDetails(product) {
    if (_.isUndefined(product)) return {};

    const additionalDetails = _.chain(product.AdditionalDetails).map('Name').reduce((results, name) => {
		results[specificKeyMapper(_.camelCase(name))] = _.find(product.AdditionalDetails, { Name: name }).Value;
		return results;
    }, {}).value();

    // Set product SKU for analytics
    additionalDetails.productSKU = product.Stockcode.toString();

    // Set image Alt value
    additionalDetails.imageAlt = additionalDetails.displayunitquantity > 1
        ? `${product.Name} ${additionalDetails.displayunitquantity} ${additionalDetails.webpacktype}`
        : `${product.Name} ${additionalDetails.webpacktype}`;

    return additionalDetails;
}

function decorator() {
    return function AdditionalDetailsDecorator(products, parentData) {
		if (_.isUndefined(products)) return products;
		_.forEach(products, (product) => {
            product.ProductData = buildAdditionalDetails(product);

            if (parentData) {
                product.ProductData.parentstockcode = parentData.PackParentStockCode.toString();
            }
		});

		return products;
	};
}

module.exports = decorator;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/detail/product/decorator/additional-details-decorator.js
 **/